// Configuración centralizada de la API.
//
// Modos:
// - VITE_API_MODE=same-origin  → rutas relativas del origen actual (laboratorio itest + nginx proxy).
// - resto                     → VITE_API_URL / heurística de host (dev 8001 / producción).
//
// IMPORTANTE: el modo same-origin NO cae en :8001 ni en URLs absolutas a :8002.

function isSameOriginMode() {
  const mode = String(import.meta.env.VITE_API_MODE || '').trim().toLowerCase();
  return mode === 'same-origin' || mode === 'itest';
}

function getApiUrl() {
  // Laboratorio itest: el navegador solo habla con el origen del frontend;
  // nginx.itest.conf reenvía /api, /uploads, /signed_documents y /static al backend-itest.
  if (isSameOriginMode()) {
    return '';
  }

  // Comportamiento histórico de entornos existentes (dev / prod).
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === '45.169.253.138' || host === 'localhost' || host === '127.0.0.1') {
      return `${window.location.protocol}//${host}:8001`;
    }
  }
  return import.meta.env.VITE_API_URL ||
    (import.meta.env.DEV ? 'http://localhost:8000' : 'https://pdfsigner.indumapps.com.co');
}

let API_URL = getApiUrl();
if (API_URL.endsWith('/api')) API_URL = API_URL.slice(0, -4);
const cleanApiUrl = API_URL.endsWith('/') ? API_URL.slice(0, -1) : API_URL;

export const API_BASE_URL = cleanApiUrl;
export const IS_ITEST_UI = isSameOriginMode();

// Los archivos viven en el backend. BASE_URL puede apuntar al host de los correos
// (en DEV, la IP privada) y no al host desde el que el navegador abrió la app.
// /uploads y /signed_documents se piden al mismo origen de la página: nginx los
// reenvía al backend. En producción el origen ya coincide y la URL no cambia.
export function resolveFileUrl(url) {
  if (!url || typeof url !== 'string') return url
  const value = url.trim()
  if (!value.startsWith('http://') && !value.startsWith('https://')) {
    const path = value.replace(/^\/+/, '')
    if (!API_BASE_URL) {
      return `/${path}`
    }
    return `${API_BASE_URL}/${path}`
  }
  if (typeof window === 'undefined' || !window.location || !window.location.origin) {
    return value
  }
  let parsed
  try {
    parsed = new URL(value)
  } catch (error) {
    return value
  }
  const path = parsed.pathname || ''
  const isStoredFile = path.startsWith('/uploads/') || path.startsWith('/signed_documents/')
  if (!isStoredFile || parsed.origin === window.location.origin) {
    return value
  }
  return `${window.location.origin}${path}${parsed.search}`
}

export default API_BASE_URL;
